import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import FlightSearchForm from "../../components/flight-search-form/FlightSearchForm.component";
// import moment from "moment";
import "./Homepage.styles.css";
// import { useNavigate } from "react-router-dom";
// import callMob from "../../assets/images/flight/book-tick.png";
import { phoneNum } from "../../utils/globalVars";
// import { useState } from "react";
import SEO from "../../utils/SEO";
import BestTour from "../../components/BestTours/BestTour";
import BestTourAu from "../../components/BestTours/BestTourAu";
import BestTourCa from "../../components/BestTours/BestTourCa";
import BestTourIn from "../../components/BestTours/BestTourIn";
import BestTourNz from "../../components/BestTours/BestTourNz";
import BestTourPh from "../../components/BestTours/BestTourPh";
import BestTourQa from "../../components/BestTours/BestTourQa";
import BestTourRp from "../../components/BestTours/BestTourRp";
import BestTourSg from "../../components/BestTours/BestTourSg";
import BestTourUAE from "../../components/BestTours/BestTourUAE";
import BestTourHk from "../../components/BestTours/BestTourHk";
import BestTourMy from "../../components/BestTours/BestTourMy";
import BestTourZa from "../../components/BestTours/BestTourZa";
import BestTourTh from "../../components/BestTours/BestTourTh";
import BestTourUk from "../../components/BestTours/BestTourUk";
import BestTourVn from "../../components/BestTours/BestTourVn";
import moment from "moment";
import { useNavigate } from "react-router-dom";

const HomePage = () => {
  // const navigate = useNavigate();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const navigate = useNavigate();

  // const handleExpClick = (origin, dest) => {
  //   navigate({
  //     pathname: "/flights",
  //     search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
  //       "YYYY-MM-DD"
  //     )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
  //   });
  // };

  // const [showPopup, setPopup] = useState('active')

  // function removePopup(){
  //   setPopup('')
  // }

  const handleExpClick = (origin, dest) => {
    localStorage.setItem(
      "formValue",
      JSON.stringify({
        startDate: moment().format("YYYY-MM-DD"),
        passengers: {
          adults: 1,
          child: 0,
        },
        departureVal: {
          iataCode: origin,
        },
        arrVal: {
          iataCode: dest,
        },
        tripType: "one-way",
      })
    );
    navigate({
      pathname: "/flights",
      search: `?search_t=${moment().unix()}&tripType=one-way&dep_loc=${origin}&dest_loc=${dest}&dep_dt=${moment().format(
        "YYYY-MM-DD"
      )}&ret_dt=null&fl_cl=ECONOMY&adt=1&chd=0`,
    });
  };

  const settings = {
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  // const offersettings = {
  //   dots: true,
  //   arrows: false,
  //   infinite: true,
  //   speed: 500,
  //   slidesToShow: 3,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   centerMode: true,
  //   centerPadding: '100px',
  //   adaptiveHeight: true,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2,
  //         centerPadding: '70px',
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         centerPadding: '50px',
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         centerPadding: '0px',
  //       }
  //     }
  //   ]
  // };

  const loadBestTour = () => {
    let urlname;
    urlname = window.location.hostname.split(".")[0];
    if (urlname === "localhost") {
      urlname = "en";
    } else {
      if (urlname === "www") {
        urlname = "en";
      }
    }

    return (
      <>
        {urlname === "AirFareHQ" ? <BestTour /> : ""}
        {urlname === "au" ? <BestTourAu /> : ""}
        {urlname === "ca" ? <BestTourCa /> : ""}
        {urlname === "hk" ? <BestTourHk /> : ""}
        {urlname === "in" ? <BestTourIn /> : ""}
        {urlname === "id" ? <BestTourRp /> : ""}
        {urlname === "my" ? <BestTourMy /> : ""}
        {urlname === "nz" ? <BestTourNz /> : ""}
        {urlname === "ph" ? <BestTourPh /> : ""}
        {urlname === "qa" ? <BestTourQa /> : ""}
        {urlname === "sg" ? <BestTourSg /> : ""}
        {urlname === "sa" ? <BestTourZa /> : ""}
        {urlname === "th" ? <BestTourTh /> : ""}
        {urlname === "en" ? <BestTour /> : ""}
        {urlname === "es" ? <BestTour /> : ""}
        {urlname === "ae" ? <BestTourUAE /> : ""}
        {urlname === "uk" ? <BestTourUk /> : ""}
        {urlname === "vn" ? <BestTourVn /> : ""}
      </>
    );
  };
  return (
    <>
      <SEO
        title="AirFareHQ -Ultimate Destination for Cheap Flight Booking"
        description="AirFareHQ - Your ultimate destination for hassle-free travel bookings. Find the best deals on flights, and embark on your dream journey today. Visit us"
      />

      <div className="home-banner">
        <div className="cm-page-center">
          <div className="search-banner">
            <h1>Let AirFareHQ bring your dream vacation to new heights.</h1>
            <FlightSearchForm />
          </div>
        </div>
      </div>

      <div className="add-section">
        <div className="cm-page-center">
          <div className="cm-flex cm-flex-wrap">
            <div className="cm-wd-50">
              <div className="column promo-col cm-flex cm-flex-wrap">
                <div className="cm-wd-20">
                  <span className="offer-tag">Offer</span>
                  <span className="curr__Icon">$</span>
                </div>
                <div className="cm-wd-80">
                  <h5>
                    Sign Up and Save Up to <span>$15 off</span>
                  </h5>
                  <p>our fees on selected regions with a promo code!</p>
                  <div className="promo-code-form">
                    <form action="">
                      <input type="text" placeholder="Enter email address" />
                      <input type="submit" value="Get Promo Code!" />
                    </form>
                  </div>
                  <p>
                    <small>Expires soon. Restrictions apply</small>
                  </p>
                </div>
              </div>
            </div>
            <div className="cm-wd-50">
              <div className="column cm-flex cm-flex-wrap">
                <div className="cm-wd-20">
                  <span className="offer-tag">Call Now</span>
                  <span className="curr__Icon">
                    <i className="fa-solid fa-phone"></i>
                  </span>
                  {/* <div className="book-mob">
                      <img src={callMob} alt="" />
                    </div> */}
                </div>
                <div className="just-booking cm-wd-80">
                  <h5>Why to book with Travel Expert</h5>
                  <ul>
                    <li>Expert guidance by our Travel experts</li>
                    <li>Immediate booking confirmation</li>
                    <li>24 hour cancellation</li>
                    <li>Plans Flexible payment</li>
                  </ul>
                  <div className="booking-call">
                    <a href={`tel:${phoneNum.label}`} className="cm-btn">
                      Call Now
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="service_section">
        <h2>Here's why travelers choose AirFareHQ</h2>
        <div className="cm-page-center cm-flex cm-flex-wrap">
          <div className="cm-wd-25">
            <i className="fa fa-get-pocket" aria-hidden="true"></i>
            <h5>Get Great Deals!</h5>
            <p>Choose from 500+ airlines for low airfares!</p>
          </div>
          <div className="cm-wd-25">
            <i className="fa fa-mars" aria-hidden="true"></i>
            <h5>Price Match Promise</h5>
            <p>Find low prices to destinations worldwide.</p>
          </div>
          <div className="cm-wd-25">
            <i className="fa fa-ban" aria-hidden="true"></i>
            <h5>Easy Cancellations with AirFareHQ</h5>
            <p>Convenient self-service options available online.</p>
          </div>
          <div className="cm-wd-25">
            <i className="fa fa-envira" aria-hidden="true"></i>
            <h5>Expert Guidance</h5>
            <p>Get personalized assistance from our travel experts.</p>
          </div>
        </div>
      </div>

      <div className="offer-section">
        <div className=" cm-page-center">
          <div className="offer-title">
            <h2>AirFareHQ Best Tours</h2>
          </div>
          <div className="offer-slider-row cm-flex cm-flex-wrap">
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("JFK", "LHR")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img
                    src="./images/traditional-gondola-near-world-famous-canal-grande-rialto-bridge.png"
                    alt=""
                  />
                </a>
                <div className="offter-text">
                  <div className="title">Thrilling Italy</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        JFK{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        LHR
                      </span>
                    </p>
                    <p>
                      <strong>$155</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("MAD", "LHR")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img
                    src="./images/colosseum-rome-morning-sun-italy.png"
                    alt=""
                  />
                </a>
                <div className="offter-text">
                  <div className="title">Big in spain</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        MAD{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        LHR
                      </span>
                    </p>
                    <p>
                      <strong>$100</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("ATL", "JFK")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img src="./images/view-great-sphinx.png" alt="" />
                </a>
                <div className="offter-text">
                  <div className="title">Trip to Ancient Egypt</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        ATL{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        JFK
                      </span>
                    </p>
                    <p>
                      <strong>$120</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("SYD", "LHR")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img
                    src="./images/downtown-chicago-skyline-sunset-illinois-usa.png"
                    alt=""
                  />
                </a>
                <div className="offter-text">
                  <div className="title">Faraway Baston</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        SYD{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        LHR
                      </span>
                    </p>
                    <p>
                      <strong>$147</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("BER", "LHR")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img
                    src="./images/paris-eiffel-tower-skyline-aerial-france.png"
                    alt=""
                  />
                </a>
                <div className="offter-text">
                  <div className="title">Colorful Paris</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        BER{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        LHR
                      </span>
                    </p>
                    <p>
                      <strong>$135</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("TYO", "BOS")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img src="./images/tokyo.jpg" alt="" />
                </a>
                <div className="offter-text">
                  <div className="title">Beautiful Tokyo</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        TYO{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        BOS
                      </span>
                    </p>
                    <p>
                      <strong>$189</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("LHR", "JFK")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img
                    src="./images/big-ben-clock-tower-london-england.png"
                    alt=""
                  />
                </a>
                <div className="offter-text">
                  <div className="title">A weekend in London</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        LHR{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        JFK
                      </span>
                    </p>
                    <p>
                      <strong>$135</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="column cm-wd-25"
              onClick={(e) => handleExpClick("AMS", "LOS")}
            >
              <div className="col-inner">
                <a href="#" className="image-box">
                  <img src="./images/amsterdam.jpg" alt="" />
                </a>
                <div className="offter-text">
                  <div className="title">Awesome Amsterdam</div>
                  <div className="cm-flex-type-1">
                    <p>
                      <span>
                        AMS{" "}
                        <i className="fa-solid fa-arrow-right-arrow-left"></i>{" "}
                        LOS
                      </span>
                    </p>
                    <p>
                      <strong>$110</strong>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="cm-section review-section">
        <div className="cm-page-center">
          <h2 className="cm-txt-center"> Customer Reviews </h2>

          <Slider {...settings} className="cm-home-guide-slider">
            <div className="cm-home-guide-slide">
              <p>
                AirFareHQ created an incredible tour for my family and relatives
                employing pocket-friendly last-minute travel flights.
              </p>
              {/* <strong>Customer Name</strong>   */}
            </div>
            <div className="cm-home-guide-slide">
              <p>
                Wonderful time with you all! The service was really helpful in
                aiding me with all aspects of my flight change procedures.
              </p>
              {/* <strong>Customer Name</strong> */}
            </div>
          </Slider>
        </div>
      </div>
    </>
  );
};

export default HomePage;
